/**
 * Tres Commas queue: bank sync target.
 * For Media Devoted | Created By Ciro Autiero
 */

import { matchTracker, type AutoPullResource, type FlowLayer, type TrackerId } from '@trafficpulse/shared';
import { autoPullKeys } from '@/features/bank-auto-pull';

export const TC_SYNC_ORDER: readonly AutoPullResource[] = ['network-rules', 'offers', 'landers', 'paths'];
const legacy = { url: '/banks/auto-pull', key: autoPullKeys.all,
  resources: (layers: FlowLayer[]): readonly AutoPullResource[] => layers };
const tc = { url: '/tres-commas/banks/auto-pull', key: ['tres-commas', 'banks', 'auto-pull'] as const,
  resources: (layers: FlowLayer[]): readonly AutoPullResource[] => layers.length ? TC_SYNC_ORDER : [] };
export function bankSyncTarget(provider: TrackerId) {
  return matchTracker<typeof legacy | typeof tc>(provider, { voluum: () => legacy, binom: () => legacy, 'tres-commas': () => tc });
}
